import { ITicketCategory, TICKET_CATEGORIES_SCHEMA } from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { IGetGateway, ISaveGateway } from '../gateways';

export class TicketCategoryGateway
  implements
    IGetGateway<null, IApiResponse<ITicketCategory[]>>,
    ISaveGateway<ITicketCategory[], IApiResponse<ITicketCategory[]>>
{
  private readonly restCallBuilder: RestCallBuilder<ITicketCategory[]> =
    new RestCallBuilder<ITicketCategory[]>([]);
  private readonly restCallBuilderDelete: RestCallBuilder<ITicketCategory[]> =
    new RestCallBuilder<ITicketCategory[]>([]);

  get(): Observable<IApiResponse<ITicketCategory[]>> {
    return this.restCallBuilder
      .get('/ticket-categories/')
      .handleMessages()
      .validate(
        API_RESPONSE_SCHEMA(TICKET_CATEGORIES_SCHEMA),
        'Ticket Categories.get'
      )
      .build();
  }

  save(
    ticketCategories: ITicketCategory[]
  ): Observable<IApiResponse<ITicketCategory[]>> {
    return this.restCallBuilder
      .post('/ticket-categories/', ticketCategories)
      .handleMessages()
      .validate(
        API_RESPONSE_SCHEMA(TICKET_CATEGORIES_SCHEMA),
        'Ticket Categories.save'
      )
      .build();
  }

  delete(query: string): Observable<IApiResponse<ITicketCategory[]>> {
    return this.restCallBuilderDelete
      .delete('/ticket-categories/' + query)
      .handleMessages()
      .validate(
        API_RESPONSE_SCHEMA(TICKET_CATEGORIES_SCHEMA),
        'Ticket Category.delete'
      )
      .build();
  }
}
